export default {"src":"/pro/_next/static/media/honey.ca29c69f.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};